// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"89798814","941":"8c8ba0b7"}[chunkId] + ".chunk.css";
};